import React from "react";
import "../css/WeWork.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Work1 from "../images/Work1.png";
import Work2 from "../images/Work2.png";
import Work3 from "../images/Work3.png";
import Work4 from "../images/Work4.png";
import Work5 from "../images/Work5.png";
import Work6 from "../images/Work6.png";
import AnimatedBack1 from "../images/AnimatedBack2.gif";
import AnimatedBack from "../images/AnimatedBack.gif";

function WeWork() {
  return (
    <>
      <Header />
      <div className="AppD">
        <div className="Appd-above">
          <img className="Appd-img" src={AnimatedBack} alt="Animated Background" />
          <div className="Appd-above-info">
            <p className="Appd-p">How We Work?</p>
          </div>
        </div>
      </div>
      <div className="Wework">
        <img className="WeWork-Animated-image" src={AnimatedBack1} alt="Process Animation" />
        <div className="Work1">
          <div className="one">01</div>
          <img className="Work1-img" src={Work1} alt="Shaping Your Vision" />
          <div className="Work1-info">
            <p className="Wework-p1">Shaping Your Vision</p>
            <p className="Wework-description">
              When clients show interest in collaborating with us, our skilled
              strategists initiate the process. Once the team aligns on a shared
              vision, we collectively dedicate ourselves to bringing the project
              to life with passion and precision.
            </p>
          </div>
          <div className="Work1-points">
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Initial Engagement</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Idea Conceptualization</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Comprehensive Research and Strategic Planning</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Approval of Requirements and Cost Estimation</p>
            </div>
          </div>
        </div>
        <p className="Wework-p2">Project Agreement</p>
        <hr className="process-divider"/>
        
        <div className="Work2">
          <div className="Work2-points">
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Perform Internal Analysis</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Create Wireframes/Prototypes/Storyboards</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Submit Resource Plan</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Select Development Platforms and Structures</p>
            </div>
          </div>
          <div className="Work2-info">
            <p className="Wework-p1">Shaping Your Vision</p>
            <p className="Wework-description">
              Once the project is approved, we progress to the pre-engineering
              phase, where the foundation of success is laid. This stage
              involves meticulous root-level construction, in-depth analysis,
              and strategic concept development. Our team provides expert
              technical consultation and finalizes detailed specifications,
              accompanied by a comprehensive resource plan.
            </p>
          </div>
          <img className="Work2-img" src={Work2} alt="Pre-Engineering" />
          <div className="two">02</div>
        </div>
        <p className="Wework-p2">Scope Sign-off</p>
        <hr className="process-divider"/>
        
        <div className="Work3">
          <div className="three">03</div>
          <img className="Work3-img" src={Work3} alt="UI/UX Design" />
          <div className="Work3-info">
            <p className="Wework-p1">Design: User Interface (UI) & User Experience (UX)</p>
            <p className="Wework-description">
              Design, to us, is not just about looks; it's about creating
              seamless functionality. Our focus is on crafting an experience
              that captivates your users, making it not only intuitive and easy
              to navigate but also engaging and enjoyable every step of the way.
            </p>
          </div>
          <div className="Work3-points">
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Analyze user demographics</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Implement modern UI trends</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Use emotional design with colors</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Personalize the user experience</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Evaluate UX with metrics</p>
            </div>
          </div>
        </div>
        <p className="Wework-p2">Visual Design Ready</p>
        <hr className="process-divider"/>
        
        <div className="Work4">
          <div className="Work4-points">
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Define a clear release plan</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Code within the set timeframe</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Develop the full-stack backend</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Regularly update project status</p>
            </div>
          </div>
          <div className="Work4-info">
            <p className="Wework-p1">Development & Implementation</p>
            <p className="Wework-description">
              At Purohit Technosoft, we rely on advanced project management
              tools like Jira, GitLab, and Hubstaff to streamline our
              development process. Our skilled developers lead the way,
              selecting the right technology to craft the perfect solution. We
              consistently update our routine status to optimize the code for
              better performance.
            </p>
          </div>
          <img className="Work4-img" src={Work4} alt="Development" />
          <div className="four">04</div>
        </div>
        <p className="Wework-p2">Optimized Code</p>
        <hr className="process-divider"/>
        
        <div className="Work5">
          <div className="five">05</div>
          <img className="Work5-img" src={Work5} alt="Testing & QA" />
          <div className="Work5-info">
            <p className="Wework-p1">Comprehensive Beta Testing & QA</p>
            <p className="Wework-description">
              The excitement begins as we bring your website or app to life! We
              implement the developed plan by creating a beta version and
              rigorously testing each module through multiple phases and
              environments to ensure the best results.
            </p>
          </div>
          <div className="Work5-points">
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Conduct static and automated tests</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Eliminate bugs</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Perform real-time user testing</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Gather valuable feedback</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Make final adjustments for optimization</p>
            </div>
          </div>
        </div>
        <p className="Wework-p2">Premier Quality</p>
        <hr className="process-divider"/>
        
        <div className="Work6">
          <div className="Work6-points">
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Seamless live deployment</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Ensure data security</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Ongoing maintenance & support</p>
            </div>
            <div className="Work-point">
              <i className="fa-solid fa-circle point-icon"></i>
              <p>Continuous performance monitoring</p>
            </div>
          </div>
          <div className="Work6-info">
            <p className="Wework-p1">Deployment & Final Launch</p>
            <p className="Wework-description">
              Get ready to unveil your masterpiece! After thorough testing and
              quality checks, our experts deploy your final product on app
              stores and web browsers, ensuring smooth approval and adherence to
              platform standards.
            </p>
          </div>
          <img className="Work6-img" src={Work6} alt="Deployment" />
          <div className="six">06</div>
        </div>
        <p className="Wework-p2 final-step">Perfectly Working App</p>
      </div>
      <Footer />
    </>
  );
}

export default WeWork;